export default "__VITE_ASSET__ConkoEmZ__"